import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { findDOMNode } from 'react-dom'
import cn from 'classnames'

export default class Dropdown extends Component {
  static propTypes = {
    label : PropTypes.string,
  };

  constructor() {
    super()
    this.state = {showing: false}
    this.toggle = this.onMouseDown.bind(this)
    this.dismiss = this.onMouseOut.bind(this)
  }

  componentWillUnmount() {
    this.eventsOff()
  }

  eventsOn() {
    document.addEventListener('mouseup', this.dismiss)
    document.addEventListener('click', this.dismiss)
  }

  eventsOff() {
    document.removeEventListener('mouseup', this.dismiss)
    document.removeEventListener('click', this.dismiss)
  }

  onMouseDown(e) {
    if (e.type == 'mousedown' && e.button != 0) return
    e.stopPropagation()
    e.preventDefault()
    const {showing} = this.state
    if (!showing) this.eventsOn()
    this.setState({showing: !showing})
  }

  onMouseOut(e) {
    const node = findDOMNode(this)
    if (node == e.target || node.contains(e.target)) return
    e.stopPropagation()
    e.preventDefault()
    this.eventsOff()
    this.setState({showing: false})
  }

  onClickItem(e) {
    e.target.click()
    this.eventsOff()
    this.setState({showing: false})
  }

  renderItem(item, i) {
    return <li
      key={i}
      onMouseDown={this.onClickItem.bind(this)}
      onMouseUp={this.onClickItem.bind(this)}
      onMouseOver={e => e.target.classList.add('hover')}
      onMouseOut={e => e.target.classList.remove('hover')}
    >{item}</li>
  }

  render() {
    const {label} = this.props
    const className = cn('dropdown', {show: this.state.showing})

    return <div className={className}>
      <a className='toggle' onMouseDown={this.toggle} onTouchEnd={this.toggle}>
        {label}
        <i className='arrow ion-ios-arrow-down' />
      </a>
      <div className='menu'>
        <ul className='list'>
          {React.Children.map(this.props.children, this.renderItem.bind(this))}
        </ul>
      </div>
    </div>
  }
}



// WEBPACK FOOTER //
// ./app/components/Dropdown.js